module.exports = __webpack_public_path__ + "img/9422.e41d7f2c.jpg";